module.exports = __webpack_public_path__ + "media/images/icons/union-ea6319ec23b574cd382e5af19cb39614.svg";